import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentOrder } from '@app/resources/ngrx/selectors';
import { ExistingTransactionDetailsCardComponent } from '@app/areas/transactions/components/existing-transaction-details-card/existing-transaction-details-card.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';

@Component({
  selector: 'app-existing-transaction',
  standalone: true,
  imports: [ExistingTransactionDetailsCardComponent, AsyncPipe, NgIf],
  template: `
    <div *ngIf="transactions$ | async; let transaction" class="existing-transaction-wrapper">
      <app-existing-transaction-details-card [transaction]="transaction" [theme]="theme" />
    </div>
  `,
  styleUrl: './existing-transaction.component.scss',
})
export class ExistingTransactionComponent implements OnInit {
  private readonly store = inject(Store);
  transactions$ = this.store.select(selectCurrentOrder);

  private readonly applicationProfileService = inject(ApplicationProfileService);
  protected theme!: PortalTheme;

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
